import VScrollLock from "v-scroll-lock";
import Vue from "vue";
Vue.use(VScrollLock, {
  bodyScrollOptions: {
    reserveScrollBarGap: true
  }
});
